import { theme } from '@frameio/vapor';

export const TRANSFER_ANIMATIONS = {
  duration: 250,
  ease: theme.transitions.eases.easeOut,
  easeAsBezierString: theme.transitions.eases.easeOut,
  'generating-thumbnail': {
    duration: 350,
    ease: 'cubic-bezier(0.17, 0.17, 0, 1)',
  },
  preparing: {
    duration: 700,
    ease: 'cubic-bezier(0.33, 0, 0, 1)',
  },
} as const;
